import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { IconViewCenterLeftComponent } from './icon-view-center-left/icon-view-center-left.component';
import { SharedMaterialModule } from '../shared/material.module';
import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [
    MenuComponent,
    IconViewCenterLeftComponent,
    HeaderComponent
  ],
  imports: [
    CommonModule,
    SharedMaterialModule
  ],
  exports: [
    IconViewCenterLeftComponent,
    HeaderComponent
  ],
})
export class LayoutModule { }
